import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { DocsList, Pendientes } from "./types";
const baseUrl = import.meta.env.VITE_URL_BACK;
console.log("url", baseUrl);

// Define a service using a base URL and expected endpoints
export const docsApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("app_token");
      if (token) {
        headers.set(`Authorization`, `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    cargaDocumento: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["cargaDocumento"],
        method: "post",
        url: "/siniestro/carga-documento",
      }),
    }),
    getValidacion: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["estatus-siniestro"],
        method: "post",
        url: "/cop/enviar-validacion",
      }),
    }),
    Dictamen: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/cop/dictamen",
      }),
    }),
    enviarAseguradora: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["estatus-siniestro"],
        method: "put",
        url: "/cop/enviar-aseguradora",
      }),
    }),
    auditoria: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["estatus-siniestro"],
        method: "post",
        url: "/cop/auditoria",
      }),
    }),
    calificarDocumento: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["cargaDocumento"],
        method: "put",
        url: "/cop/guardar-calificacion",
      }),
    }),
    finalizarValidacion: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["cargaDocumento"],
        method: "put",
        url: "/cop/finalizar-validacion",
      }),
    }),
    getDocsList: builder.query<DocsList, any>({
      keepUnusedDataFor: 0,
      providesTags: ["cargaDocumento"],
      query: (info: any) =>
        `/siniestro/documentos/${info.siniestro}/${info.tramite}`,
    }),
    getPendientes: builder.query<Pendientes, void>({
      keepUnusedDataFor: 0,
      query: () => `/cop/mis-pendientes`,
    }),
    getProcesoActual: builder.query<any, any>({
      keepUnusedDataFor: 0,
      providesTags: ["estatus-siniestro"],
      query: (info: any) =>
        `/cop/proceso-actual/${info.siniestro}/${info.tramite}`,
    }),
    getCallcenter: builder.query<any, any>({
      keepUnusedDataFor: 0,
      query: (info: any) => `/cop/callcenter/${info.siniestro}/${info.tramite}`,
    }),
    saveCallcenter: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/cop/callcenter",
      }),
    }),
    getFinalizado: builder.query<any, any>({
      keepUnusedDataFor: 0,
      query: (info: any) => `/cop/finalizado/${info.siniestro}/${info.tramite}`,
    }),
    catRespuestas: builder.query<any, any>({
      keepUnusedDataFor: 0,
      query: (info: any) =>
        `/cop/cat-respuesta/${info.siniestro}/${info.tramite}`,
    }),
    getDictamenes: builder.query<any, any>({
      keepUnusedDataFor: 0,
      query: (info: any) => `/cop/dictamenes/${info.siniestro}/${info.tramite}`,
    }),
    getSemaforo: builder.query<any, any>({
      keepUnusedDataFor: 0,
      query: (info: any) => `/cop/tiempos/${info.siniestro}/${info.tramite}`,
    }),
    getBusqueda: builder.query<any, void>({
      keepUnusedDataFor: 0,
      query: () => `/cop/buscar`,
    }),
    getReportes: builder.query<any, void>({
      keepUnusedDataFor: 0,
      query: () => `/cop/reportes`,
    }),
    buscarTramite: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/cop/buscar",
      }),
    }),
    generarReporte: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/cop/reportes",
      }),
    }),
    getSiniestro: builder.query<any, any>({
      query: (siniestro: any) => `/cop/informacion-siniestro/${siniestro}`,
    }),
    getEtapasTramite: builder.query<any, any>({
      query: (info: any) =>
        `/siniestro/etapas/${info.siniestro}/${info.tramite}`,
    }),
    login: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["sesion"],
        method: "post",
        url: "/auth/login",
      }),
    }),
    validarSesion: builder.query<any, void>({
      query: () => "/auth/check-status",
    }),
    getNotificaciones: builder.query<any, any>({
      keepUnusedDataFor: 0,
      query: (info: any) =>
        `/cop/notificaciones/${info.siniestro}/${info.tramite}`,
    }),
    documentoAdicional: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/cop/documento-adicional",
      }),
    }),
    getDocumentosAdicionales: builder.query<any, any>({
      keepUnusedDataFor: 0,
      query: (info: any) =>
        `/cop/documentos-adicionales/${info.siniestro}/${info.tramite}`,
    }),
    eliminardocAdi: builder.mutation({
      query: (post) => ({
        body: post,
        method: "put",
        url: "/cop/documento-adicional",
      }),
    }),
    buscarPoliza: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/siniestro/buscar-poliza",
      }),
    }),
    nuevoTramite: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/siniestro/nuevo-tramite",
      }),
    }),
    datosTramite: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/siniestro/datos-tramite",
      }),
    }),
    editarDocumento: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/siniestro/documento-tramite",
      }),
    }),
    getReportesEmision: builder.query<any, void>({
      query: () => `/emisiones/reportes`,
    }),
    getPendientesFull: builder.query<any, void>({
      query: () => `/emisiones/pendientes-full`,
    }),
    getValidaciones: builder.query<any, void>({
      query: () => `/cop/validaciones`,
    }),
    generarReporteEmision: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/emisiones/reporte-emision",
      }),
    }),
    getTipoConsultaEmision: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/emisiones/busqueda",
      }),
    }),
    ConsultaEmision: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/emisiones/busqueda-emision",
      }),
    }),

    getPoliza: builder.query<any, any>({
      query: (poliza_id: any) => `/siniestro/buscar-poliza/${poliza_id}`,
    }),
    buscarEspecialista: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/cop/buscar-especialista",
      }),
    }),
    eliminarTramite: builder.mutation({
      query: (post) => ({
        body: post,
        method: "put",
        url: "/cop/eliminar-tramite",
      }),
    }),
    agregarEspecialista: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/cop/agregar-especialista",
      }),
    }),
    getTramitesSinAsignar: builder.query<any, void>({
      query: () => `/cop/tramites-sin-asignar`,
    }),
    asignarTramites: builder.mutation({
      query: (post) => ({
        body: post,
        method: "put",
        url: "/cop/asignar-tramites",
      }),
    }),
    getEspecialistas: builder.query<any, void>({
      keepUnusedDataFor: 0,
      query: () => `/cop/especialistas`,
    }),
    rmEspecialista: builder.mutation({
      query: (post) => ({
        body: post,
        method: "put",
        url: "/cop/especialistas",
      }),
    }),
    cargarCondiciones: builder.mutation({
      query: (post) => ({
        body: post,
        method: "post",
        url: "/siniestro/carga-condiciones",
      }),
    }),
    cargarFormato: builder.mutation({
      query: (post) => ({
        body: post,
        method: "put",
        url: "/cop/formato-reclamacion",
      }),
    }),
    getWakaway: builder.query<any, void>({
      query: () => `/cop/wakaway`,
    }),
    getEnviarWalkaway: builder.mutation({
      query: (post) => ({
        body: post,
        invalidatesTags: ["estatus-siniestro"],
        method: "post",
        url: "/cop/enviar-walkaway",
      }),
    }),
  }),
  reducerPath: "api",
  tagTypes: ["sesion", "cargaDocumento", "estatus-siniestro"],
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDocsListQuery,
  useValidarSesionQuery,
  useLazyValidarSesionQuery,
  useLoginMutation,
  useGetPendientesQuery,
  useGetSiniestroQuery,
  useGetProcesoActualQuery,
  useCargaDocumentoMutation,
  useLazyGetDocsListQuery,
  useLazyGetPendientesQuery,
  useGetValidacionMutation,
  useCalificarDocumentoMutation,
  useFinalizarValidacionMutation,
  useEnviarAseguradoraMutation,
  useCatRespuestasQuery,
  useDictamenMutation,
  useAuditoriaMutation,
  useGetCallcenterQuery,
  useSaveCallcenterMutation,
  useGetFinalizadoQuery,
  useGetDictamenesQuery,
  useGetSemaforoQuery,
  useGetBusquedaQuery,
  useBuscarTramiteMutation,
  useGetNotificacionesQuery,
  useDocumentoAdicionalMutation,
  useLazyGetDocumentosAdicionalesQuery,
  useEliminardocAdiMutation,
  useGetEtapasTramiteQuery,
  useBuscarPolizaMutation,
  useNuevoTramiteMutation,
  useDatosTramiteMutation,
  useEditarDocumentoMutation,
  useGetReportesEmisionQuery,
  useGenerarReporteEmisionMutation,
  useGetTipoConsultaEmisionMutation,
  useConsultaEmisionMutation,
  useLazyGetPendientesFullQuery,
  useGetPolizaQuery,
  useGetValidacionesQuery,
  useBuscarEspecialistaMutation,
  useAgregarEspecialistaMutation,
  useGetTramitesSinAsignarQuery,
  useAsignarTramitesMutation,
  useLazyGetTramitesSinAsignarQuery,
  useGetEspecialistasQuery,
  useLazyGetEspecialistasQuery,
  useRmEspecialistaMutation,
  useCargarCondicionesMutation,
  useGetReportesQuery,
  useGenerarReporteMutation,
  useEliminarTramiteMutation,
  useCargarFormatoMutation,
  useGetWakawayQuery,
  useGetEnviarWalkawayMutation,
} = docsApi;
